import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { queryGetAgents, getMe } from "Apollo";
import { Scrollbars } from "react-custom-scrollbars";
import Popover from "module-common/Popover";
import Header from "./HeaderWithQueryMutation";
import Row from "./Row";

const MAX_AGENT_SHOWN = 6;
const ROW_HEIGHT = 50;

export default graphql(queryGetAgents, {
  options: {
    pollInterval: 300000,
    fetchPolicy: "network-only"
  }
})(
  class OnlineStatus extends Component {
    render() {
      const data = this.props.data;
      const agents = data && data.getAgents;
      if (!agents) return null;

      //prepare list of agent to render except this agent
      const me = getMe().agent;
      const renders = [];
      agents.forEach(agent => {
        if (agent.id !== me.id) {
          renders.push(
            <Row
              key={agent.id}
              displayPicture={agent.displayPicture}
              displayName={agent.displayName}
              status={agent.onlineStatus.onlineStatusType.name}
            />
          );
        }
      });

      // calculate panel height
      let count = renders.length;
      if (count > MAX_AGENT_SHOWN) count = MAX_AGENT_SHOWN;
      const height = count * ROW_HEIGHT;

      return (
        <Popover
          {...this.props}
          margin={10}
          position="right"
          show="click"
          hide="click-outside"
          content={
            <Wrapper>
              <Header />
              <List height={height}>
                <Scrollbars>{renders}</Scrollbars>
              </List>
            </Wrapper>
          }
        >
          {this.props.children}
        </Popover>
      );
    }
  }
);

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 200px;
  background-color: white;
  box-shadow: ${props => props.theme.shadow};
  border-radius: 4px;
  bottom: -30px;
  &:after {
    content: " ";
    position: absolute;
    border: 10px solid;
    right: 100%;
    bottom: 20px;
    border-color: transparent white transparent transparent;
  }
`;
const List = styled.div`
  height: ${props => props.height}px;
`;



// WEBPACK FOOTER //
// ./src/module-sidemenu/online-status/OnlineStatusWithQuery.js